import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import { doctor03 } from "../../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import config from "../../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Profile = () => {
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(true);

  const userId = localStorage.getItem("userUUID");

  // Fetch user data
  useEffect(() => {
    if (userId) {
      fetch(`${config.API_URL}get_userdata.php?user_id=${userId}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success === "1") {
            setUserInfo(data.user);
          } else {
            toast.error(data.message || "Failed to fetch user data.");
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          toast.error("Error fetching user data.");
        })
        .finally(() => setLoading(false));
    } else {
      toast.error("User ID not found.");
      setLoading(false);
    }
  }, [userId]);

  // Format date of birth
  // const formatDate = (dob) => {
  //   if (!dob) return "Not provided";
  //   const date = new Date(dob);
  //   return date.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
  // };

  return (
    <>
      <ToastContainer />
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-7 col-6">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <i className="feather-chevron-right">
                    <FeatherIcon icon="chevron-right" />
                  </i>
                </li>
                <li className="breadcrumb-item active">My Profile</li>
              </ul>
            </div>
            <div className="col-sm-5 col-6 text-end m-b-30">
              <Link to="/edit-profile" className="btn btn-primary btn-rounded">
                <i className="fa fa-plus" /> Edit Profile
              </Link>
            </div>
          </div>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <>
              <div className="card-box profile-header">
                <div className="row">
                  <div className="col-md-12">
                    <div className="profile-view">
                      <div className="profile-img-wrap">
                        <div className="profile-img">
                        <Link to="#">
                            <img
                              className="avatar"
                              src={
                                userInfo.profile_image
                                  ? `${config.API_URL}uploads/profile_images/user_images/${userInfo.profile_image}`
                                  : doctor03
                              }
                              alt="Business Profile"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="profile-basic">
                        <div className="row">
                          <div className="col-md-5">
                            <div className="profile-info-left">
                              <h3 className="user-name m-t-0 mb-0">
                                {userInfo.first_name || "First"} {userInfo.last_name || "Last"}
                              </h3>
                              <small className="text-muted">User</small>
                              <div className="staff-id">User ID: {userId || "N/A"}</div>
                              <div className="staff-id">
                                Profile Completion: {userInfo.profile_completion || 0}%
                              </div>
                              <div className="staff-msg">
                                {/* <Link to="/chat" className="btn btn-primary">
                                  Send Message
                                </Link> */}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <ul className="personal-info">
                              <li>
                                <span className="title">Phone:</span>
                                <span className="text">
                                  <Link to="#">{userInfo.phone || "Not provided"}</Link>
                                </span>
                              </li>
                              <li>
                                <span className="title">Email:</span>
                                <span className="text">
                                  <Link to="#">{userInfo.email || "Not provided"}</Link>
                                </span>
                              </li>
                              <li>
                                <span className="title">Date of Birth:</span>
                                <span className="text">{userInfo.dob}</span>
                              </li>
                              <li>
                                <span className="title">Address:</span>
                                <span className="text">
                                  {userInfo.address_line1 || ""}{" "}
                                  {userInfo.address_line2 ? `, ${userInfo.address_line2}` : ""}{" "}
                                  {userInfo.city || ""} {userInfo.state || ""}{" "}
                                  {userInfo.pin_code || ""}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile-tabs">
                <ul className="nav nav-tabs nav-tabs-bottom">
                  <li className="nav-item">
                    <Link className="nav-link active" to="#about-cont" data-bs-toggle="tab">
                      About
                    </Link>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane show active" id="about-cont">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card-box">
                          <h3 className="card-title">Personal Information</h3>
                          <div className="experience-box">
                            <ul className="experience-list">
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Full Name</span>
                                    <div>
                                      {userInfo.first_name || "Not provided"}{" "}
                                      {userInfo.last_name || "Not provided"}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Email</span>
                                    <div>{userInfo.email || "Not provided"}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Phone</span>
                                    <div>{userInfo.phone || "Not provided"}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Date of Birth</span>
                                    <div>{userInfo.dob}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Address</span>
                                    <div>
                                      {userInfo.address_line1 || ""}{" "}
                                      {userInfo.address_line2 ? `, ${userInfo.address_line2}` : ""}{" "}
                                      {userInfo.city || ""} {userInfo.state || ""}{" "}
                                      {userInfo.pin_code || ""}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="experience-user">
                                  <div className="before-circle" />
                                </div>
                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <span className="name">Profile Completion</span>
                                    <div>{userInfo.profile_completion || 0}%</div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;